/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserIdentity } from './UserIdentity';
export type FileView = {
  readonly id?: number;
  uploaded_by: UserIdentity;
  readonly generation_job_external_id?: string;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  readonly uploaded_date?: string;
  filename: string;
  file_type: FileView.file_type;
  file_path: string;
  guid: string;
  external_id?: string | null;
  json_file_path?: string | null;
  /**
   * Secondary classification of the document (e.g., CAP_TABLE, BALANCE_SHEET)
   */
  document_reference_secondary_classification?: FileView.document_reference_secondary_classification | null;
  generation_job?: number | null;
};
export namespace FileView {
  export enum file_type {
    CSV = 'csv',
    DOC = 'doc',
    DOCX = 'docx',
    DOCM = 'docm',
    GIF = 'gif',
    JPEG = 'jpeg',
    JPG = 'jpg',
    KEY = 'key',
    MD = 'md',
    NUMBERS = 'numbers',
    PAGES = 'pages',
    PDF = 'pdf',
    PNG = 'png',
    PPT = 'ppt',
    PPTX = 'pptx',
    PPSM = 'ppsm',
    PPTM = 'pptm',
    RTF = 'rtf',
    TXT = 'txt',
    XLS = 'xls',
    XLSX = 'xlsx',
    XLSM = 'xlsm',
    XLSB = 'xlsb',
    ZIP = 'zip',
  }
  /**
   * Secondary classification of the document (e.g., CAP_TABLE, BALANCE_SHEET)
   */
  export enum document_reference_secondary_classification {
    CAP_TABLE = 'CAP_TABLE',
    BALANCE_SHEET = 'BALANCE_SHEET',
    INCOME_STATEMENT = 'INCOME_STATEMENT',
    CASH_FLOW_STATEMENT = 'CASH_FLOW_STATEMENT',
    OTHER = 'OTHER',
  }
}
